'use strict';

export function ActivityFeedTypeDomainProvider() {
  return {
    $get: [
      'FirebaseUtil',
      'AbstractDomainClass',
      function (
        FirebaseUtil,
        AbstractDomainClass,
      ) {
        //console.log('Calling ActivityFeedTypeDomain');
        function ActivityFeedTypeDomain(data) {
          AbstractDomainClass.call(this, ActivityFeedTypeDomain, data);
        }

        AbstractDomainClass.__inheritFrom(ActivityFeedTypeDomain, 'ActivityFeedTypeDomain', 'activity-feed-types');

        ActivityFeedTypeDomain.$constraints.addConstraints({
          name: {type: 'string'},

          feeds: {type: 'DomainCollection', domainClass: 'ActivityFeedDomain', link: 'type'}
        });

        // more methods go here;

        ActivityFeedTypeDomain.prototype.toString = function () {
          return this.name;
        };

        return ActivityFeedTypeDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/activity-feed/domain/ActivityFeedTypeDomain.js